<script setup lang="ts">
import { ref } from 'vue';
import { storeToRefs } from 'pinia';
import Dialog from 'primevue/dialog';
import MultiSelect from 'primevue/multiselect';
import { useRelayHubStore } from '@/store';
import { EMIT } from '@/enum';

const relayHubStore = useRelayHubStore();

const { statesAbleToConnect } = storeToRefs(relayHubStore);
const selectedItems = ref<number[]>([]);

const emit = defineEmits<{
  (e: EMIT.CANCEL): void;
  (e: EMIT.SAVE): void;
}>();

const modalVisible = ref(true);

const save = async () => {
  await relayHubStore.addNewStates(selectedItems.value);

  let stateName = 'State';
  if (selectedItems.value.length > 1) stateName = 'States';

  if (relayHubStore.error) relayHubStore.doToast(relayHubStore.error as string, 'Error', true);
  else relayHubStore.doToast(`${stateName} Connected`);

  selectedItems.value = [];
  emit(EMIT.SAVE);
};

const cancel = () => {
  selectedItems.value = [];
  emit(EMIT.CANCEL);
};
</script>

<template>
  <Dialog v-model:visible="modalVisible" class="dialog__container" :modal="true" :draggable="false" @hide="cancel">
    <template #header>
      <div class="dialog__header flex flex-column w-8">
        <h2 class="mb-3">Connect States</h2>
      </div>
    </template>
    <div clas="flex flex-column ">
      <div class="w-full my-3 flex flex-column gap-1">
        <label for="organizations" class="required">States</label>
        <MultiSelect
          id="organizations"
          v-model="selectedItems"
          filter
          class="w-full"
          :options="statesAbleToConnect"
          option-label="name"
          option-value="id"
          :loading="relayHubStore.loading"
          placeholder="Select States to Enable"
        />
      </div>
    </div>
    <template #footer>
      <AppButton type="secondary" text="Cancel" @click="cancel" />
      <AppButton type="primary" text="Add States" :disabled="!selectedItems.length" @click="save" />
    </template>
  </Dialog>
</template>
